import restClient, { HttpService } from 'src/services/http.service';
import { AuthStore } from '../auth/auth.store';
import { ChangeRequestStore } from '../change-request/change-request.store';
import ConfigurationStore from '../configuration/configuration.store';
import { CorporateOnboardingStore } from '../corporate/onboarding.store';
import { RegistrationStore } from '../registration.store';
import { UserStore } from '../user';
import { IndividualBorrowerOnboardingStore } from '../user/individual-borrower-onboarding.store';
import { IndividualFunderOnboardingStore } from '../user/individual-funder-onboarding.store';
import { OnboardingStore } from '../user/onboarding.store';
import { ApplicationStore } from './application.store';
import eventEmitter from '../event';
import { CheckingSelfieImageStore } from '../checking-selfie-image/checking-selfie-image.store';
import { mortgageApplicationList } from '../mortgage-deal/mortgage-deal-application.store';
import { mortgageDealDetailsStore } from '../mortgage-deal/mortgage-deal-details.store';
import { GuarantorStore } from '../guarantor/guarantor.store';
import { MortgagePaymentStore } from '../mortgage-deal/mortgage-payment.store';
import { MortgageInvestmentStore } from '../mortgage-deal/mortage-investment.store';
import { FunderInvestmentStore } from '../mortgage-deal/funder-investment.store';
import { BorrowerInvestmentStore } from '../mortgage-deal/borrower-investment.store';
import { FunderInvestmentDetailStore } from '../mortgage-deal/funder-investment-detail.store';
import { ChangeRequestHistoryStore } from '../change-request/change-request-history.store';

export interface IRootStore {
	authStore: AuthStore;
	userStore: UserStore;
	configuration: ConfigurationStore;
	registrationStore: RegistrationStore;
	individualFunderOnboardingStore: IndividualFunderOnboardingStore;
	individualBorrowerOnboardingStore: IndividualBorrowerOnboardingStore;
	applicationStore: ApplicationStore;
	onboardingStore: OnboardingStore;
	corporateOnboardingStore: CorporateOnboardingStore;
	changeRequestStore: ChangeRequestStore;
	checkingSelfieImage: CheckingSelfieImageStore;
	mortgageApplicationList: mortgageApplicationList;
	mortgageDealDetails: mortgageDealDetailsStore;
	guarantorStore: GuarantorStore;
	mortgagePaymentStore: MortgagePaymentStore;
	mortgageInvestmentStore: MortgageInvestmentStore;
	funderInvestmentStore: FunderInvestmentStore;
	borrowerInvestmentStore: BorrowerInvestmentStore;
	funderInvestmentDetailStore: FunderInvestmentDetailStore;
	changeRequestHistoryStore: ChangeRequestHistoryStore;
}
export type RootStoreChildType = keyof IRootStore;

export class RootStore implements IRootStore {
	authStore: AuthStore;
	userStore: UserStore;
	configuration: ConfigurationStore;
	httpClient: HttpService;
	registrationStore: RegistrationStore;
	individualFunderOnboardingStore: IndividualFunderOnboardingStore;
	individualBorrowerOnboardingStore: IndividualBorrowerOnboardingStore;
	applicationStore: ApplicationStore;
	onboardingStore: OnboardingStore;
	corporateOnboardingStore: CorporateOnboardingStore;
	changeRequestStore: ChangeRequestStore;
	checkingSelfieImage: CheckingSelfieImageStore;
	mortgageApplicationList: mortgageApplicationList;
	mortgageDealDetails: mortgageDealDetailsStore;
	guarantorStore: GuarantorStore;
	mortgagePaymentStore: MortgagePaymentStore;
	mortgageInvestmentStore: MortgageInvestmentStore;
	funderInvestmentStore: FunderInvestmentStore;
	borrowerInvestmentStore: BorrowerInvestmentStore;
	funderInvestmentDetailStore: FunderInvestmentDetailStore;
	changeRequestHistoryStore: ChangeRequestHistoryStore;

	constructor() {
		this.configuration = new ConfigurationStore();
		this.httpClient = restClient;
		this.onboardingStore = new OnboardingStore(this.httpClient);
		this.applicationStore = new ApplicationStore();
		
		this.userStore = new UserStore(this.httpClient, this.onboardingStore, this.applicationStore);
		this.individualFunderOnboardingStore = new IndividualFunderOnboardingStore(this.httpClient, this.onboardingStore, this.userStore);
		this.individualBorrowerOnboardingStore = new IndividualBorrowerOnboardingStore(this.httpClient, this.userStore);
		this.authStore = new AuthStore(this.httpClient, this.userStore, this.onboardingStore);
		this.registrationStore = new RegistrationStore(this.httpClient, this.authStore);
		this.corporateOnboardingStore = new CorporateOnboardingStore(this.httpClient, this.onboardingStore, this.userStore);
		this.changeRequestStore = new ChangeRequestStore(this.httpClient, this.userStore);
		this.checkingSelfieImage = new CheckingSelfieImageStore(this.httpClient);
		this.mortgageApplicationList = new mortgageApplicationList(this.httpClient);
		this.mortgageDealDetails = new mortgageDealDetailsStore(this.httpClient);
		this.guarantorStore = new GuarantorStore(this.httpClient);
		this.mortgagePaymentStore = new MortgagePaymentStore(this.httpClient, this.applicationStore);
		this.mortgageInvestmentStore = new MortgageInvestmentStore(this.httpClient);
		this.funderInvestmentStore = new FunderInvestmentStore(this.httpClient);
		this.borrowerInvestmentStore = new BorrowerInvestmentStore(this.httpClient);
		this.funderInvestmentDetailStore = new FunderInvestmentDetailStore(this.httpClient);
		this.changeRequestHistoryStore = new ChangeRequestHistoryStore(this.httpClient);
		eventEmitter.on('logout', () => {
			this.userStore.dispose();
			this.individualFunderOnboardingStore.dispose();
			this.individualBorrowerOnboardingStore.dispose();
			this.authStore.dispose();
			this.changeRequestStore.dispose();
			this.corporateOnboardingStore.dispose();
			this.guarantorStore.dispose();
			this.funderInvestmentStore.dispose();
			this.borrowerInvestmentStore.dispose();
			this.changeRequestHistoryStore.dispose();
		});
	}
}
